module.exports = __webpack_public_path__ + "img/115.4.d88ee3de.png";